export const getHttpUrl = (path) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  return `${baseUrl}${path}`;
};

export const getWebSocketUrl = (path) => {
  const baseUrl = process.env.REACT_APP_WS_URL;
  return `${baseUrl}${path}`;
};
